import {Dispatch, SetStateAction, useCallback, useMemo} from 'react'
import {useGetProjectMedicalDevices} from '@/features/projects/queries/useGetProjectMedicalDevices'
import {CardInEditModeType} from '@/pages/project-details-diagnoses-facilities/ProjectDetailsDiagnosesFacilities'
import {ProjectMedicalDevicesForm} from '@/features/projects/components/project-medical-devices-form/ProjectMedicalDevicesForm'
import {ProjectMedicalDevicesDetails} from '@/features/projects/components/project-medical-devices-details/ProjectMedicalDevicesDetails'

interface ProjectMedicalDevicesSectionProps {
    projectId: string
    editModeState: [CardInEditModeType, Dispatch<SetStateAction<CardInEditModeType>>]
}

export const ProjectMedicalDevicesSection = ({projectId, editModeState}: ProjectMedicalDevicesSectionProps) => {
    const [cardInEditMode, setCardInEditMode] = editModeState

    const {
        data: medicalDevices,
        isLoading,
        isError
    } = useGetProjectMedicalDevices({
        urlParams: {projectId}
    })

    const handleCancel = useCallback(() => {
        setCardInEditMode(null)
    }, [setCardInEditMode])

    const handleEdit = useCallback(() => {
        setCardInEditMode('ProjectMedicalDevicesSection')
    }, [setCardInEditMode])

    const isActive = useMemo(() => cardInEditMode === 'ProjectMedicalDevicesSection', [cardInEditMode])
    const isDisabled = useMemo(
        () => !!(cardInEditMode && cardInEditMode !== 'ProjectMedicalDevicesSection'),
        [cardInEditMode]
    )

    if (isActive) {
        return (
            <ProjectMedicalDevicesForm
                projectId={projectId}
                defaultValues={medicalDevices}
                isDisabled={isDisabled}
                isEditModeActive={isActive}
                handleCancel={handleCancel}
                handleEdit={handleEdit}
            />
        )
    }

    return (
        <ProjectMedicalDevicesDetails
            medicalDevices={medicalDevices}
            isDisabled={isDisabled}
            isLoading={isLoading}
            isError={isError}
            isActive={isActive}
            handleCancel={handleCancel}
            handleEdit={handleEdit}
        />
    )
}
